module.exports = __webpack_public_path__ + "static/media/iconValores3.efa39fd9.svg";